// ===== Subscription Status =====
export const SubscriptionStatus = {
  ACTIVE: 'ACTIVE',
  TRIALING: 'TRIALING',
  PAST_DUE: 'PAST_DUE',
  EXPIRED: 'EXPIRED',
  CANCELED: 'CANCELED',
} as const;

export type SubscriptionStatus = (typeof SubscriptionStatus)[keyof typeof SubscriptionStatus];

export const SubscriptionStatusLabels: Record<SubscriptionStatus, string> = {
  ACTIVE: 'Активна',
  TRIALING: 'Пробный период',
  PAST_DUE: 'Просрочена',
  EXPIRED: 'Истекла',
  CANCELED: 'Отменена',
};

export const SubscriptionStatusColors: Record<SubscriptionStatus, string> = {
  ACTIVE: 'bg-green-100 text-green-700',
  TRIALING: 'bg-blue-100 text-blue-700',
  PAST_DUE: 'bg-yellow-100 text-yellow-700',
  EXPIRED: 'bg-red-100 text-red-700',
  CANCELED: 'bg-gray-100 text-gray-700',
};

// ===== Payment Status =====
export const PaymentStatus = {
  PENDING: 'PENDING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  REFUNDED: 'REFUNDED',
} as const;

export type PaymentStatus = (typeof PaymentStatus)[keyof typeof PaymentStatus];

export const PaymentStatusLabels: Record<PaymentStatus, string> = {
  PENDING: 'Ожидает',
  SUCCEEDED: 'Оплачен',
  FAILED: 'Ошибка',
  REFUNDED: 'Возврат',
};

// ===== Billing Response Types =====
export interface SubscriptionStatusResponse {
  id: number;
  status: SubscriptionStatus;
  plan_name: string;
  plan_price_kopecks: number;
  current_period_start: string;
  current_period_end: string;
  trial_end: string | null;
  grace_period_end: string | null;
  is_trial: boolean;
  is_grace: boolean;
  days_remaining: number;
}

export interface PaymentHistoryItem {
  id: number;
  amount_kopecks: number;
  status: PaymentStatus;
  paid_at: string | null;
  description: string | null;
  created_at: string;
}

export interface PaymentHistoryResponse {
  items: PaymentHistoryItem[];
  total: number;
}

export interface CreatePaymentResponse {
  confirmation_url: string;
  payment_id: number;
}
